import { memo } from "react";
import { FlightPrebookGenericSubmitErrorModal } from "../FlightPrebookGenericSubmitErrorModal";
import { FlightPrebookInsuranceErrorModal } from "../FlightPrebookInsuranceErrorModal";
import { FlightPrebookPriceChangeModal } from "../FlightPrebookPriceChangeModal";
import { FlightPrebookSubmitErrorModalProps } from "./types";

function FlightPrebookSubmitErrorModal(
  props: FlightPrebookSubmitErrorModalProps
) {
  if (!props.visible) {
    return null;
  }

  if ("variant" in props && props.variant === "INSURANCE_FAILED") {
    return <FlightPrebookInsuranceErrorModal {...props} />;
  }

  if ("variant" in props && props.variant === "PRICE_CHANGED") {
    return <FlightPrebookPriceChangeModal {...props} />;
  }

  return <FlightPrebookGenericSubmitErrorModal {...props} />;
}

export default memo(FlightPrebookSubmitErrorModal);
